<script setup lang="ts">
import TableEmptyText from '@/components/texts/TableEmptyText.vue';

export interface DataItem {
  id: string;
  model: string;
  description: string;
  quantity: string;
  weight: string;
  goodsCode: string;
}

export interface Props {
  data?: DataItem[];
}
const props = withDefaults(defineProps<Props>(), {
  data: () => [],
});
</script>

<template>
  <table
    data-testid="legProductsCustomTable"
    :class="$style.legProductsCustomTable"
  >
    <thead>
      <tr>
        <th :class="$style.modelTh">Name</th>
        <th :class="$style.descriptionTh">Description</th>
        <th :class="$style.quantityTh">Quantity</th>
        <th :class="$style.weightTh">Weight (kg)</th>
        <th :class="$style.goodsCodeTh">Code</th>
      </tr>
    </thead>
    <tr v-if="!props.data?.length">
      <td colspan="5" class="border-b-0 p-0">
        <TableEmptyText>No AirRoad products</TableEmptyText>
      </td>
    </tr>
    <tbody v-else>
      <template v-for="dataItem in props.data" :key="dataItem.id">
        <tr>
          <td :class="$style.modelTd">{{ dataItem.model }}</td>
          <td :class="$style.descriptionTd">{{ dataItem.description }}</td>
          <td :class="$style.quantityTd">{{ dataItem.quantity }}</td>
          <td :class="$style.weightTd">{{ dataItem.weight }}</td>
          <td :class="$style.goodsCodeTd">{{ dataItem.goodsCode }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.legProductsCustomTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  text-align: left;

  & > thead > tr,
  & > tbody > tr,
  & > tr {
    & > th {
      font-weight: 500;
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > td {
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > th:first-child,
    & > td:first-child {
      padding-left: 0;
    }
    & > th:last-child,
    & > td:last-child {
      padding-right: 0;
    }
  }
}
  .modelTh {
    width: 50%;
  }
  .descriptionTh {
    width: 50%;
  }
  .quantityTh {
  }
  .weightTh {
    white-space: nowrap;
  }
  .goodsCodeTh {
  }
  .modelTd {
    width: 50%;
  }
  .descriptionTd {
    width: 50%;
  }
  .quantityTd {
  }
  .weightTd {
  }
  .goodsCodeTd {
  }
</style>
